
export const makeUniqueItemKey = (item, index, prefix = 'nav-item') => {
  const { id, caption, title, eid } = item;
  const keyPart = [id, caption, title, eid].filter(val => val).join('-');
  return `${prefix}-${index}-${keyPart}`;
};
